export default {
  ACTION_UPDATE_SETTINGS: 'ACTION_UPDATE_SETTINGS'
};



// WEBPACK FOOTER //
// ./src/store/modules/setting/constants.js